import { DeliveryBike, DeliveryCar, DeliveryMotorcycle } from '@creditornot/cb-icons';
import { MenuActionItem } from '@creditornot/cb-menu';
import { Popover } from '@creditornot/cb-popover';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import BulkCourierRestrictionModal, { ModalType } from './BulkCourierRestrictionModal';
import ActionButton from '../ActionButton';

type BulkConnectProductsProps = {
  selectedIds: Set<string>;
};

const OptionPopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 240px;
  padding: 8px;
`;

const Action = styled(MenuActionItem)`
  & + & {
    margin-block-start: 8px;
  }
`;

export const BulkCourierRestriction = ({ selectedIds }: BulkConnectProductsProps) => {
  const [showCourierRestrictionOptions, setShowCourierRestrictionOptions] = useState(false);
  const [showModal, setShowModal] = useState<ModalType | undefined>();
  const menuPermissions = useOfferingMenuPermissionsContext();

  return (
    <>
      <Popover
        open={showCourierRestrictionOptions}
        renderArrow={false}
        placement="bottom-start"
        offset={4}
        content={
          <OptionPopoverContent>
            <Action
              icon={<DeliveryBike />}
              variant="black"
              onClick={() => {
                setShowModal('disableBikeDelivery');
                setShowCourierRestrictionOptions(false);
              }}
            >
              <FormattedMessage id="menu.bulkActions.courierRestrictions.disableBikeDelivery" />
            </Action>
            <Action
              icon={<DeliveryCar />}
              variant="black"
              onClick={() => {
                setShowModal('disableCarDelivery');
                setShowCourierRestrictionOptions(false);
              }}
            >
              <FormattedMessage id="menu.bulkActions.courierRestrictions.disableCarDelivery" />
            </Action>
            <Action
              icon={<DeliveryMotorcycle />}
              variant="black"
              onClick={() => {
                setShowModal('disableMotorcycleDelivery');
                setShowCourierRestrictionOptions(false);
              }}
            >
              <FormattedMessage id="menu.bulkActions.courierRestrictions.disableMotorcycleDelivery" />
            </Action>
          </OptionPopoverContent>
        }
      >
        {({ refProps }) => (
          <div {...refProps}>
            <ActionButton
              disabled={!menuPermissions.contentEdit}
              icon={<DeliveryBike />}
              onClick={() => setShowCourierRestrictionOptions(!showCourierRestrictionOptions)}
              tooltipTitle={<FormattedMessage id="menu.bulkActions.courierRestrictions.title" />}
            />
          </div>
        )}
      </Popover>

      {showModal && (
        <BulkCourierRestrictionModal
          onClose={() => setShowModal(undefined)}
          selectedIds={selectedIds}
          modalType={showModal}
        />
      )}
    </>
  );
};
